export default __webpack_public_path__ + "static/media/img5.c885cf8b.png";